export enum TransactionType {
  SHIPPING = 0,
  CLICK_AND_COLLECT = 1,
  RADIUS_DELIVERY = 2,
  DOWNLOAD = 3,
  CASHDESC = 4,
}
